angular.module('GlobalControllers')

  .service('share', ['$mdToast', '$mdBottomSheet', function($mdToast, $mdBottomSheet) {

    this.bottom = function(title, description, url) {
      $mdBottomSheet.show({
      templateUrl: '/ng1/www/modules/global/share/html/bottom-sheet-grid-template.html',
      controller: ["$scope", "$mdBottomSheet", function($scope, $mdBottomSheet) {
        $scope.data = {
          "title": title,
          "description": description,
          "url": window.location
        };
        $scope.listItemClick = function() {
          $mdBottomSheet.hide();
        };
      }]
    });
    };

  }
  ]);
